import { render, staticRenderFns } from "./CustomCardTable.vue?vue&type=template&id=27b7a0f8&scoped=true&"
import script from "./CustomCardTable.vue?vue&type=script&lang=js&"
export * from "./CustomCardTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomCardTable.vue?vue&type=style&index=0&id=27b7a0f8&scoped=true&lang=scss&"
import style1 from "./CustomCardTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b7a0f8",
  null
  
)

export default component.exports